const AppPaths = {
  Home: "/home",
  Tracks: "/tracks",
  Login: "/login",
  Auth: "/auth",
};

export default AppPaths;
